import OldInspectionsPage from './OldInspectionsPage';

export default OldInspectionsPage;
